const splashBackground = require('./splash-bg.webp');
const splashBackgroundTablet = require('./splash-bg-tablet.webp');
const splashBackground01 = require('./splash-bg-01.webp');
const splashBackground02 = require('./splash-bg-02.webp');
const splashBackground03 = require('./splash-bg-03.webp');
const splashBackground04 = require('./splash-bg-04.webp');

const splashBackgroundTablet01 = require('./splash-bg-tablet-01.webp');
const splashBackgroundTablet02 = require('./splash-bg-tablet-02.webp');
const splashBackgroundTablet03 = require('./splash-bg-tablet-03.webp');
const splashBackgroundTablet04 = require('./splash-bg-tablet-04.webp');

const splashLogo = require('./splash-logo.png');
const playerPathwayImage = require('./img-player-pathway-mark.png');
const appLogo = require('./app-logo.png');
const avatarDefault = require('./avatar-default.png');
const profileBackground = require('./profile-bg.png');
const playerPathwayLevel1_3 = require('./img-docs-1-3.png');
const playerPathwayLevel4_5 = require('./img-docs-4-5.png');

export {
  appLogo,
  avatarDefault,
  playerPathwayImage,
  playerPathwayLevel1_3,
  playerPathwayLevel4_5,
  profileBackground,
  splashBackground,
  splashBackground01,
  splashBackground02,
  splashBackground03,
  splashBackground04,
  splashBackgroundTablet,
  splashBackgroundTablet01,
  splashBackgroundTablet02,
  splashBackgroundTablet03,
  splashBackgroundTablet04,
  splashLogo,
};
